import { DocumentNode, gql } from '@apollo/client';
import {
  Divider,
  IconButton,
  IconButtonProps,
  Menu,
  MenuButton,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import * as React from 'react';

import { MoreHorizontalIcon } from '@/imports/ui/chakra/feather';

import { DropdownMenu_PostFragment } from './graphql-types/DropdownMenu_PostFragment';

import { AnnouncePostDropdownItem } from './components/AnnouncePostDropdownItem';
import { DeletePostDropdownItem } from './components/DeletePostDropdownItem';
import { EditPostDropdownItem } from './components/EditPostDropdownItem';
import { PinPostDropdownItem } from './components/PinPostDropdownItem';
import { PostNowDropdownItem } from './components/PostNowDropdownItem';
import { ReportPostDropdownItem } from './components/ReportPostDropdownItem';

const POST_FRAGMENT = gql`
  fragment DropdownMenu_PostFragment on PostV2 {
    _id
    __typename
    datePublished
    currentUserCanUpdatePost
    currentUserCanEditPinnedState
    currentUserCanEditAnnouncedState
    pinned
    announcement {
      _id
    }
    ...PinPostDropdownItem_PostFragment
    ...AnnouncePostDropdownItem_PostFragment
    ...ReportPostDropdownItem_PostFragment
    ...DeletePostDropdownItem_PostFragment
    ...EditPostDropdownItem_PostFragment
    ...PostNowDropdownItem_PostFragment
  }
  ${PinPostDropdownItem.postFragment}
  ${AnnouncePostDropdownItem.postFragment}
  ${ReportPostDropdownItem.postFragment}
  ${DeletePostDropdownItem.postFragment}
  ${EditPostDropdownItem.postFragment}
  ${PostNowDropdownItem.postFragment}
`;

export const DropdownMenu: React.FC<
  {
    post: DropdownMenu_PostFragment;
  } & IconButtonProps
> & {
  postFragment: DocumentNode;
} = ({ post, ...buttonProps }) => {
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        variant="ghost"
        colorScheme="gray"
        icon={<MoreHorizontalIcon />}
        size="sm"
        {...buttonProps}
      />
      <Portal>
        <MenuList>
          {post.currentUserCanEditPinnedState && (
            <PinPostDropdownItem post={post} />
          )}
          {post.currentUserCanEditAnnouncedState && (
            <AnnouncePostDropdownItem post={post} />
          )}
          {!!post.datePublished && <ReportPostDropdownItem post={post} />}
          {post.currentUserCanUpdatePost && (
            <EditPostDropdownItem post={post} />
          )}
          {!post.datePublished && <PostNowDropdownItem post={post} />}
          <Divider />
          <DeletePostDropdownItem post={post} />
        </MenuList>
      </Portal>
    </Menu>
  );
};

DropdownMenu.postFragment = POST_FRAGMENT;
